// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group[data-v-9ffd4a98]{border-bottom:1px #f4f4f4 solid}.group[data-v-9ffd4a98]:last-child{border-bottom:0}.canceled[data-v-9ffd4a98]{text-decoration:line-through}\n", ""]);
// Exports
module.exports = exports;
